import TableFooter from './TableFooter'

export { TableFooter }
export default TableFooter
